import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiDialogContext } from '@taiga-ui/core';
import { TuiFiles, TuiRadio } from '@taiga-ui/kit';
import { injectContext } from '@taiga-ui/polymorpheus';


enum ImportType {
  Shapefile = 'Shapefile',
  GeoJson = 'GeoJson'
}

export type ImportTypeString = `${ImportType}`;


@Component({
  selector: 'app-import-features',
  imports: [ReactiveFormsModule, FormsModule, TuiFiles, CommonModule,TuiRadio],
  template: `

<section class="flex flex-col gap-2 py-2">
  <h2 class="text-lg font-semibold">
    Select Import Type
  </h2>

  <!-- Container for radio buttons -->
  <div class="flex gap-1">
    <label class="flex items-center gap-1">
      <input
        tuiRadio
        type="radio"
        [ngModel]="importType()"
        (ngModelChange)="importType.set($event)"
        value="Shapefile"
      />
      ShapeFile
    </label>

    <label class="flex items-center gap-1">
      <input
      disabled
        tuiRadio
        type="radio"
        [ngModel]="importType()"
        (ngModelChange)="importType.set($event)"
        value="GeoJson"
      />
      GeoJson
    </label>
  </div>
</section>

<section class="flex flex-col gap-2">

<h2 class="text-lg font-semibold">
    Select File
  </h2>
    <label tuiInputFiles>
      <input
        tuiInputFiles
        [accept]="acceptedTypes()"
        [multiple]="true"
        [ngModel]="files"
        (ngModelChange)="onChange($event)"
        (reject)="onReject($event)"
      />
      <ng-template let-dragged>
        <div *ngIf="dragged; else base" class="flex h-40 flex-col items-center justify-center gap-4">
          <tui-avatar appearance="secondary" src="@tui.droplet" />
          <div>
            Drop it!
            <br />
            <br />
          </div>
        </div>
        <ng-template #base>
          <div class="flex h-40 flex-col items-center justify-center gap-4">
            <tui-avatar appearance="secondary" src="@tui.cloud-upload" />
            <div>
              Drag and drop file here or
              <a tuiLink>click to upload</a>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </label>
    <tui-files class="tui-space_top-1">
    <tui-file
        *ngFor="let file of files()"
        state="normal"
        [file]="file"
        (remove)="onRemove(file)"
    />
</tui-files>
    </section>
    <div class="p-2 flex justify-end">
  <button
    class="bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded mr-2"
    (click)="context.$implicit.complete()"
  >
    Cancel
  </button>
  <button
    [disabled]="!canSubmit()"
    class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded disabled:bg-blue-300 disabled:cursor-not-allowed"
    (click)="submit()"
  >
    Confirm
  </button>
</div>
  `,
})
export class ImportFeaturesComponent implements OnInit {


  public readonly context = injectContext<TuiDialogContext<{importType: ImportTypeString, file: File},void >>();

  protected files = signal<File[]>([]);
  protected rejected = signal<File[]>([]);

  importType = signal<ImportTypeString>('Shapefile');

  acceptedTypes = computed(() => {
    const importType = this.importType();

    switch (importType) {
      case ImportType.Shapefile:

        return '.zip,application/zip';

      case ImportType.GeoJson:

        return '.geojson,application/geo+json';

      default:
        return '';
    }
  })

  protected onRemove(remove: File): void {
    this.files.update(files => files.filter((file) => file !== remove))
    this.rejected.update(files => files.filter((file) => file !== remove))
  }

  protected onChange(files: File[]): void {

    const rejected = this.rejected();

    this.files.set( files.filter((file) => !rejected.includes(file)))
  }

  protected onReject(rejected: File[]): void {
    this.rejected.set(rejected);
  }

  protected canSubmit = computed(() => {
    const files = this.files();

    return files.length > 0;
  })

  protected submitModel = computed(() => {
    const files = this.files();
    const importType = this.importType();


    if(files.length == 0)
      return null;

    const file = files[0];

    return {importType, file}
  })

  constructor() {}

  ngOnInit() {}

  submit()
  {
    if(!this.canSubmit() || this.submitModel() == null)
      return;


    this.context.completeWith(this.submitModel())
  }
}
